import React, { useContext } from 'react';
import 'twin.macro';
import Page, { PageContext } from '@leuven2030/framework/Page/Page';
import { useRouter } from 'next/router';
import NewsCardGrid from '@leuven2030/food/News/NewsCardGrid';
import { StyleContent } from '@leuven2030/food/styles/general';
import NewsSubscribe from '@leuven2030/food/News/NewsSubscribe';
import NewsFilters from '@leuven2030/food/News/NewsFilters';
import NewsProvider from '@leuven2030/food/News/NewsProvider';
import CalendarItem from '@leuven2030/food/Calendar/CalendarItem';

const NewsPage = ({ Layout }) => {
  const {
    prismic: {
      allNews_articles: { edges },
      news_page: { title, description }
    }
  } = useContext(PageContext);
  const router = useRouter();
  const { group } = router.query;

  return (
    <>
      <Layout tw="flex flex-col bg-white">
        <NewsProvider>
          <div tw="bg-primary-400 py-12">
            <div css={StyleContent}>
              <div tw="flex flex-col space-y-6 sm:(flex-row items-start justify-between space-x-3 space-y-0) w-full">
                <div tw="space-y-4">
                  <h1 tw="text-white font-black text-3xl sm:text-4xl">
                    {title}
                  </h1>
                  <p tw="text-white text-lg lowercase">{description}</p>
                </div>
                <div>
                  <NewsSubscribe
                    tw="flex lg:mt-0 lg:justify-end px-0 sm:px-2 text-primary-400"
                    color="light"
                    buttonColor="white"
                  />
                </div>
              </div>
            </div>
          </div>
          <div css={StyleContent} tw="">
            <div tw="py-12">
              <NewsFilters />
            </div>
            <div tw="pt-4 pb-12">
              {group === 'event' ? (
                <div>
                  {edges
                    .filter((v) => {
                      return v.node.group._meta.uid === 'event';
                    })
                    .sort((a, b) => {
                      return a.node.event_date_start < b.node.event_date_start;
                    })
                    .map((e, index) => {
                      const { node } = e;
                      return <CalendarItem {...node} key={index} />;
                    })}
                </div>
              ) : (
                <NewsCardGrid />
              )}
            </div>
          </div>
        </NewsProvider>
      </Layout>
    </>
  );
};

export default Page(NewsPage);
